import { Observable } from 'rxjs'
import { switchMap, take } from 'rxjs/operators'

import { HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http'
import { inject } from '@angular/core'
import { Store } from '@ngrx/store'

import { AppState } from '../core.state'

import { settingSelectors } from '../settings/settings.selectors'
import { environment } from 'src/environments/environment'

export function LanguageHeaderInterceptor(
  req: HttpRequest<unknown>,
  next: HttpHandlerFn
): Observable<HttpEvent<unknown>> {
  const store = inject(Store<AppState>)

  return store.select(settingSelectors.selectById, 'language').pipe(
    take(1),
    switchMap((language) => {
      if (language && req.url.includes(environment.backendApiUrl)) {
        const clonedReq = req.clone({
          setHeaders: {
            'x-custom-lang': language
          }
        })

        return next(clonedReq)
      }

      return next(req)
    })
  )
}
